"use client";

import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useColorScheme } from "@mui/material/styles";
import Link from "next/link";

const NewsletterSection = styled(Box)<{ isDarkMode: boolean }>(
  ({ theme, isDarkMode }) => ({
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    backgroundColor: "#42A6F6",
    color: "white",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: isDarkMode
        ? "linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 50%, #0d1117 100%)"
        : "linear-gradient(135deg, #42A6F6 0%, #0D47A1 100%)",
    },
  })
);

const Newsletter: React.FC = () => {
  const { mode, systemMode } = useColorScheme();
  const isDarkMode =
    mode === "dark" || (mode === "system" && systemMode === "dark");

  return (
    <NewsletterSection isDarkMode={isDarkMode}>
      <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 600,
              mb: 2,
            }}
          >
            Join the movement
          </Typography>

          <Typography
            variant="h6"
            component="p"
            sx={{
              fontSize: { xs: "1.125rem", md: "1.25rem" },
              fontWeight: 400,
              opacity: 0.9,
              lineHeight: 1.6,
              maxWidth: "600px",
            }}
          >
            We&apos;re building Bouncepoint <em>with</em> — not just for — the
            insolvency community. Sign up for product updates, exclusive
            previews, and early community access.
          </Typography>
          <Link href="/contactUs" passHref style={{ textDecoration: "none" }}>
            <Button
              variant="outlined"
              sx={{
                backgroundColor: "white",
                borderColor: "white",
                color: "#42A6F6",
                fontWeight: 600,
                py: 1.5,
                px: 4,
                "&:hover": {
                  backgroundColor: "#42A6F6",
                  color: "white",
                  borderColor: "#42A6F6",
                },
                ...(isDarkMode && {
                  backgroundColor: "#42A6F6",
                  borderColor: "#42A6F6",
                  color: "#F7A56F",
                  fontWeight: 700,
                  "&:hover": {
                    backgroundColor: "#F49045",
                    borderColor: "#F49045",
                    color: "#1a1a1a",
                  },
                }),
              }}
            >
              Sign up
            </Button>
          </Link>
        </Stack>
      </Container>
    </NewsletterSection>
  );
};

export default Newsletter;
